import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { usePermissions } from "../store/usePermissions.store";
import { clearTokens, saveNamekToken } from "../store/tokens.store";
import { OrionV2AuthenticateResponseT } from "../services/orionv2";

/**
 * Gestiona la session del usuario.
 *
 * Se encarga de guardar datos en el store y gestión de storages
 */
export const useSessionMan = () => {
  const queryClient = useQueryClient();
  const sessionLocalId = usePermissions((state) => state.sessionLocalId);
  const startSessionStore = usePermissions((state) => state.startSession);
  const clearSessionStore = usePermissions((state) => state.clearSession);
  const isSignedIn = usePermissions((state) => state.isSignedIn);

  const startSession = useCallback(
    (user: OrionV2AuthenticateResponseT) => {
      startSessionStore(user);
      saveNamekToken(user.token);
    },
    [startSessionStore],
  );

  const clearSession = useCallback(() => {
    sessionStorage.clear();
    queryClient.removeQueries();
    clearTokens();
  }, [queryClient]);

  const endSession = useCallback(
    (options?: { reloadWindow?: boolean }) => {
      const { reloadWindow = false } = options || {};
      if (sessionLocalId) {
        sessionStorage.clear();
        queryClient.removeQueries();
        clearTokens();
        clearSession();
        clearSessionStore();
        if (reloadWindow) {
          window.location.reload();
        }
      }
    },
    [queryClient, sessionLocalId, clearSession, clearSessionStore],
  );

  return {
    isSignedIn,
    startSession,
    endSession,
    clearSession,
  };
};
